import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { RegulatoryItemEndpoint } from './regulatoryitemendpoint.service';
import { RegulatoryItemDto } from '../models/regulatoryitem.model';
import { DepartmentDto } from '../models/Department.model';
import { AgencyDto } from '../models/Agency.model';
import { LegislationDto } from '../models/Legislation.model';
import { RegulatoryUpdateDto } from '../models/RegulatoryUpdate.model';
import { RegulatoryUpdateTypeVldDto } from '../models/RegulatoryUpdateTypeVld.model';
import { RegulatoryItemTypeVldDto } from '../models/RegulatoryItemTypeVld.model';
import { ExternalDocumentDto } from '../models/ExternalDocument.model';
import { FileUploadDto } from '../models/FileUpload.model';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';


@Injectable()

export class RegulatoryItemService {
  constructor(private router: Router, private regulatoryItemEndpoint: RegulatoryItemEndpoint) {
  }

  getRegulatoryItemTypes(userProfileID?: string) {

    return this.regulatoryItemEndpoint.getRegulatoryItemTypes<RegulatoryItemTypeVldDto[]>(userProfileID);
    ////let item11 = new RegulatoryItemTypeVldDto();
    ////item11.regulatoryItemTypeVldID = 1;
    ////item11.regulatoryItemTypeDescription = "Act";

    ////let item1 = new RegulatoryItemTypeVldDto();
    ////item1.regulatoryItemTypeVldID = 1;
    ////item1.regulatoryItemTypeDescription = "Regulation";

    ////let item2 = new RegulatoryItemTypeVldDto();
    ////item2.regulatoryItemTypeVldID = 2;
    ////item2.regulatoryItemTypeDescription = "Policy";


    ////let item3 = new RegulatoryItemTypeVldDto();
    ////item3.regulatoryItemTypeVldID = 3;
    ////item3.regulatoryItemTypeDescription = "Form";


    //////let item4 = new AgencyVldDto();
    //////item4.agencyVldID = 4;
    //////item4.departmentName = "Service Alberta";

    ////let requlatoryItems: RegulatoryItemTypeVldDto[] = [item11, item1, item2, item3];

    ////return requlatoryItems;
    
  }

  getRegulatoryUpdateTypes(userProfileID?: string) {

    return this.regulatoryItemEndpoint.getRegulatoryUpdateTypes<RegulatoryUpdateTypeVldDto[]>(userProfileID);

    ////let item1 = new RegulatoryUpdateTypeVldDto();
    ////item1.regulatoryUpdateTypeVldID = 1;
    ////item1.regulatoryUpdateTypeDescription = "Baseline Count";


    ////let item2 = new RegulatoryUpdateTypeVldDto();
    ////item2.regulatoryUpdateTypeVldID = 2;
    ////item2.regulatoryUpdateTypeDescription = "Update";


    //////let item3 = new AgencyVldDto();
    //////item3.agencyVldID = 3;
    //////item3.departmentName = "Advanced Education";

    //////let item4 = new AgencyVldDto();
    //////item4.agencyVldID = 4;
    //////item4.departmentName = "Service Alberta";

    ////let requlatoryItems: RegulatoryUpdateTypeVldDto[] = [item1, item2];

    ////return requlatoryItems;

    //return this.costRecoveryChargeEndpoint.getCostRecoveryChargeById<CostRecoveryChargeDto>(costRecoveryChargeId);

  }

  getDepartments(userProfileID?: string) {

    return this.regulatoryItemEndpoint.getDepartments<DepartmentDto[]>(userProfileID);

    ////let item1 = new DepartmentDto();
    ////item1.departmentID = "1";
    ////item1.departmentName = "Children’s Services";

    ////let item2 = new DepartmentDto();
    ////item2.departmentID = "2";
    ////item2.departmentName = "Treasury Board and Finance";

    ////let item3 = new DepartmentDto();
    ////item3.departmentID = "3";
    ////item3.departmentName = "Advanced Education";

    ////let item4 = new DepartmentDto();
    ////item4.departmentID = "4";
    ////item4.departmentName = "Service Alberta";

    ////let requlatoryItems: DepartmentDto[] = [item1, item2, item3, item4];

    ////return requlatoryItems;

    //return this.costRecoveryChargeEndpoint.getCostRecoveryChargeById<CostRecoveryChargeDto>(costRecoveryChargeId);

  }

  getPSDepartments(userProfileID?: string) {
    return this.regulatoryItemEndpoint.getPSDepartments<DepartmentDto[]>(userProfileID);
  }
  getAgencies(departmentId?: string, userProfileID?: string) {

    return this.regulatoryItemEndpoint.getAgencies<AgencyDto[]>(departmentId, userProfileID);

    ////let item1 = new AgencyDto();
    ////item1.agencyID = "0";
    ////item1.agencyName = "All";

    ////let item2 = new AgencyDto();
    ////item2.agencyID = "1";
    ////item2.agencyName = "Alberta Liquor Control Board";

    
    ////let agencies: AgencyDto[] = [item2];

    ////return agencies;

    //return this.costRecoveryChargeEndpoint.getCostRecoveryChargeById<CostRecoveryChargeDto>(costRecoveryChargeId);

  }

  getLegislations(departmentId?: string, userProfileID?: string) {

    return this.regulatoryItemEndpoint.getLegislations<LegislationDto[]>(departmentId, userProfileID);

    ////let item1 = new LegislationDto();
    ////item1.legislationID = "1";
    ////item1.legislationName = "Child Care Act";

    ////let item2 = new LegislationDto();
    ////item2.legislationID = "2";
    ////item2.legislationName = "Alberta Corporate Tax Act";

    ////let requlatoryItems: LegislationDto[] = [item1, item2];

    ////return requlatoryItems;

    //////return this.costRecoveryChargeEndpoint.getCostRecoveryChargeById<CostRecoveryChargeDto>(costRecoveryChargeId);

  }
  
  getAllRegulatoryItems(userProfileID?: string) {
       
    return this.regulatoryItemEndpoint.getAllRegulatoryItems<RegulatoryItemDto[]>(userProfileID);

    ////let item11 = new RegulatoryItemDto();
    ////item11.regulatoryItemID = "1";
    ////item11.departmentName = "Children’s Services";
    ////item11.agencyName = "";
    ////item11.legislationName = "Child Care Act";
    ////item11.regulatoryItemName = "Child Care Act";
    ////item11.regulatoryItemTypeDescription = "Act";
    ////item11.baseline = 100;
    ////item11.updates = 0;
    ////item11.netChange = 0;
    ////item11.currentCount = 100;
    ////item11.netChangePercent = 0;


    ////let item1 = new RegulatoryItemDto();
    ////item1.regulatoryItemID = "1";
    ////item1.departmentName = "Children’s Services";
    ////item1.agencyName = "";
    ////item1.legislationName = "Child Care Act";
    ////item1.regulatoryItemName = "Assisted Living Regulation";
    ////item1.regulatoryItemTypeDescription = "Regulation";
    ////item1.baseline =100;
    ////item1.updates = 0;
    ////item1.netChange = 0;
    ////item1.currentCount = 100;
    ////item1.netChangePercent = 0;

    ////let item22 = new RegulatoryItemDto();
    ////item22.regulatoryItemID = "2";
    ////item22.departmentName = "Treasury Board and Finance";
    ////item22.agencyName = "";
    ////item22.legislationName = "Alberta Corporate Tax Act";
    ////item22.regulatoryItemName = "Alberta Corporate Tax Act";
    ////item22.regulatoryItemTypeDescription = "Act";
    ////item22.baseline = 100;
    ////item22.updates = 0;
    ////item22.netChange = 0;
    ////item22.currentCount = 100;
    ////item22.netChangePercent = 0;

    ////let item2 = new RegulatoryItemDto();
    ////item2.regulatoryItemID = "2";
    ////item2.departmentName = "Treasury Board and Finance";
    ////item2.agencyName = "";
    ////item2.legislationName = "Alberta Corporate Tax Act";
    ////item2.regulatoryItemName = "Alberta Corporate Tax Regulation";
    ////item2.regulatoryItemTypeDescription = "Regulation";
    ////item2.baseline = 100;
    ////item2.updates = 0;
    ////item2.netChange = 0;
    ////item2.currentCount = 100;
    ////item2.netChangePercent = 0;

    ////let item3 = new RegulatoryItemDto();
    ////item3.regulatoryItemID = "3";
    ////item3.departmentName = "Children’s Services";
    ////item3.agencyName = "";
    ////item3.legislationName = "Child Care Act";
    ////item3.regulatoryItemName = "Caregiver Policy";
    ////item3.regulatoryItemTypeDescription = "Policy";
    ////item3.baseline = 100;
    ////item3.updates = 0;
    ////item3.netChange = 0;
    ////item3.currentCount = 100;
    ////item3.netChangePercent = 0;

    ////let item4 = new RegulatoryItemDto();
    ////item4.regulatoryItemID = "3";
    ////item4.departmentName = "Children’s Services";
    ////item4.agencyName = "";
    ////item4.legislationName = "Child Care Act";
    ////item4.regulatoryItemName = "Child Care Application form";
    ////item4.regulatoryItemTypeDescription = "Form";
    ////item4.baseline = 100;
    ////item4.updates = 0;
    ////item4.netChange = 0;
    ////item4.currentCount = 100;
    ////item4.netChangePercent = 0;

    ////let requlatoryItems: RegulatoryItemDto[] = [item11, item1, item22, item2, item3, item4];

    ////return requlatoryItems;

    //return this.costRecoveryChargeEndpoint.getCostRecoveryChargeById<CostRecoveryChargeDto>(costRecoveryChargeId);

  }

  getRegulatoryItemsByLegislation(departmentId?: string, legislationID?: string, userProfileID?: string) {

    return this.regulatoryItemEndpoint.getRegulatoryItemsByLegislation<RegulatoryItemDto[]>(departmentId, legislationID, userProfileID);

    ////let item1 = new RegulatoryItemDto();
    ////item1.regulatoryItemID = "1";
    ////item1.departmentName = "Children’s Services";
    ////item1.agencyName = "";
    ////item1.legislationName = "Child Care Act";
    ////item1.regulatoryItemName = "Assisted Living Regulation";
    ////item1.regulatoryItemTypeDescription = "Regulation";
    ////item1.baseline = 100;
    ////item1.updates = 0;
    ////item1.netChange = 0;
    ////item1.currentCount = 100;
    ////item1.netChangePercent = 0;

    ////let item2 = new RegulatoryItemDto();
    ////item2.regulatoryItemID = "2";
    ////item2.departmentName = "Treasury Board and Finance";
    ////item2.agencyName = "";
    ////item2.legislationName = "Alberta Corporate Tax Act";
    ////item2.regulatoryItemName = "Alberta Corporate Tax Regulation";
    ////item2.regulatoryItemTypeDescription = "Regulation";
    ////item2.baseline = 100;
    ////item2.updates = 0;
    ////item2.netChange = 0;
    ////item2.currentCount = 100;
    ////item2.netChangePercent = 0;

    ////let item3 = new RegulatoryItemDto();
    ////item3.regulatoryItemID = "3";
    ////item3.departmentName = "Children’s Services";
    ////item3.agencyName = "";
    ////item3.legislationName = "Child Care Act";
    ////item3.regulatoryItemName = "Caregiver Policy";
    ////item3.regulatoryItemTypeDescription = "Policy";
    ////item3.baseline = 100;
    ////item3.updates = 0;
    ////item3.netChange = 0;
    ////item3.currentCount = 100;
    ////item3.netChangePercent = 0;

    ////let item4 = new RegulatoryItemDto();
    ////item4.regulatoryItemID = "3";
    ////item4.departmentName = "Children’s Services";
    ////item4.agencyName = "";
    ////item4.legislationName = "Child Care Act";
    ////item4.regulatoryItemName = "Child Care Application form";
    ////item4.regulatoryItemTypeDescription = "Form";
    ////item4.baseline = 100;
    ////item4.updates = 0;
    ////item4.netChange = 0;
    ////item4.currentCount = 100;
    ////item4.netChangePercent = 0;

    ////let requlatoryItems: RegulatoryItemDto[] = [item1, item2, item3, item4];

    ////return requlatoryItems;

  }

  getRegulatoryItemsByAgency(departmentId?: string, agencyID?: string, userProfileID?: string) {

    return this.regulatoryItemEndpoint.getRegulatoryItemsByAgency<RegulatoryItemDto[]>(departmentId, agencyID, userProfileID);

    ////let item1 = new RegulatoryItemDto();
    ////item1.regulatoryItemID = "1";
    ////item1.departmentName = "Children’s Services";
    ////item1.agencyName = "";
    ////item1.legislationName = "Child Care Act";
    ////item1.regulatoryItemName = "Assisted Living Regulation";
    ////item1.regulatoryItemTypeDescription = "Regulation";
    ////item1.baseline = 100;
    ////item1.updates = 0;
    ////item1.netChange = 0;
    ////item1.currentCount = 100;
    ////item1.netChangePercent = 0;

    ////let item2 = new RegulatoryItemDto();
    ////item2.regulatoryItemID = "2";
    ////item2.departmentName = "Treasury Board and Finance";
    ////item2.agencyName = "";
    ////item2.legislationName = "Alberta Corporate Tax Act";
    ////item2.regulatoryItemName = "Alberta Corporate Tax Regulation";
    ////item2.regulatoryItemTypeDescription = "Regulation";
    ////item2.baseline = 100;
    ////item2.updates = 0;
    ////item2.netChange = 0;
    ////item2.currentCount = 100;
    ////item2.netChangePercent = 0;

    ////let item3 = new RegulatoryItemDto();
    ////item3.regulatoryItemID = "3";
    ////item3.departmentName = "Children’s Services";
    ////item3.agencyName = "";
    ////item3.legislationName = "Child Care Act";
    ////item3.regulatoryItemName = "Caregiver Policy";
    ////item3.regulatoryItemTypeDescription = "Policy";
    ////item3.baseline = 100;
    ////item3.updates = 0;
    ////item3.netChange = 0;
    ////item3.currentCount = 100;
    ////item3.netChangePercent = 0;

    ////let item4 = new RegulatoryItemDto();
    ////item4.regulatoryItemID = "3";
    ////item4.departmentName = "Children’s Services";
    ////item4.agencyName = "";
    ////item4.legislationName = "Child Care Act";
    ////item4.regulatoryItemName = "Child Care Application form";
    ////item4.regulatoryItemTypeDescription = "Form";
    ////item4.baseline = 100;
    ////item4.updates = 0;
    ////item4.netChange = 0;
    ////item4.currentCount = 100;
    ////item4.netChangePercent = 0;
    ////let requlatoryItems: RegulatoryItemDto[] = [item1, item2, item3, item4];

    ////return requlatoryItems;

    //return this.costRecoveryChargeEndpoint.getCostRecoveryChargeById<CostRecoveryChargeDto>(costRecoveryChargeId);

  }
  
  getRegulatoryItem(regulatoryItemID?: string, userProfileID?: string) {

    return this.regulatoryItemEndpoint.getRegulatoryItem<RegulatoryItemDto>(regulatoryItemID, userProfileID);

    ////let item1 = new RegulatoryItemDto();
    ////item1.regulatoryItemID = "1";
    ////item1.departmentName = "Children’s Services";
    ////item1.agencyName = "";
    ////item1.legislationName = "Child Care Act";
    ////item1.regulatoryItemName = "Assisted Living Regulation";
    ////item1.regulatoryItemTypeDescription = "Regulation";
    ////item1.baseline = 100;
    ////item1.updates = 0;
    ////item1.netChange = 0;
    ////item1.currentCount = 100;
    ////item1.netChangePercent = 0;

    ////item1.regulatoryUpdates = this.getItemUpdatesByItem();
    ////return item1;
  }

  getPdfManageRegulatoryCount(departmentId?: string, legislationId?: string, agencyId?: string) {
    return this.regulatoryItemEndpoint.getPdfManageRegulatoryCount<Blob>(departmentId, legislationId, agencyId);
  }

  getPdfManageRegulatoryCountUrl(departmentId?: string, legislationId?: string, agencyId?: string): string {
    return this.regulatoryItemEndpoint.getPdfManageRegulatoryCountUrl<string>(departmentId, legislationId, agencyId);
  }

  createRegulatoryItem() {

    return this.regulatoryItemEndpoint.createRegulatoryItem<RegulatoryItemDto>();

    ////let item1 = new RegulatoryItemDto();
    ////item1.regulatoryItemID = "1";
    ////item1.departmentName = "Children’s Services";
    ////item1.agencyName = "";
    ////item1.legislationName = "Child Care Act";
    ////item1.regulatoryItemName = "Assisted Living Regulation";
    ////item1.regulatoryItemTypeDescription = "Regulation";
    ////item1.baseline = 100;
    ////item1.updates = 0;
    ////item1.netChange = 0;
    ////item1.currentCount = 100;
    ////item1.netChangePercent = 0;

    ////item1.regulatoryUpdates = this.getItemUpdatesByItem();
    ////return item1;
  }


  getItemUpdatesByItem() {

    ////let item1 = new RegulatoryUpdateDto();
    ////item1.regulatoryUpdateID = "1";
    ////item1.updateType = "Baseline Count";
    ////item1.regulatoryUpdateTypeVldID = 1;
    ////item1.effectiveDate = new Date("12/12/2018");
    ////item1.netChange = 155;
    ////item1.comments = "";
    ////item1.createdDate = new Date("12/12/2018");
    ////item1.createdBy = "RTR User";
    
    ////let item2 = new RegulatoryUpdateDto();
    ////item2.regulatoryUpdateID = "2";
    ////item2.regulatoryUpdateTypeVldID = 2;
    ////item2.updateType = "Update";
    ////item2.effectiveDate = new Date("12/12/2018");
    ////item2.netChange = 4;
    ////item2.comments = "Act amendments";
    ////item2.createdDate = new Date("12/12/2018");
    ////item2.createdBy = "RTR User";
    ////item2.externalDocuments = this.getExternalDocuments();

    ////let item3 = new RegulatoryUpdateDto();
    ////item3.regulatoryUpdateID = "3";
    ////item3.regulatoryUpdateTypeVldID = 2;
    ////item3.updateType = "Update";
    ////item3.effectiveDate = new Date("12/12/2018");
    ////item3.netChange = -4;
    ////item3.comments = "Act amendments";
    ////item3.createdDate = new Date("12/12/2018");
    ////item3.createdBy = "RTR User";



    ////let requlatoryItems: RegulatoryUpdateDto[] = [item1, item2, item3];

    ////return requlatoryItems;

    //return this.costRecoveryChargeEndpoint.getCostRecoveryChargeById<CostRecoveryChargeDto>(costRecoveryChargeId);

  }

  getExternalDocuments() {

    let item1 = new ExternalDocumentDto();
    item1.regulatoryUpdateID = "1";
    item1.externalDocumentID = "1";
    item1.documentFileName = "Form 1";
    item1.comments = "";
    
    //let item2 = new ExternalDocumentDto();
    //item2.regulatoryUpdateID = "2";
    //item2.regulatoryUpdateTypeVldID = 2;
    //item2.updateType = "Update";
    //item2.effectiveDate = new Date("12/12/2018");
    //item2.netChange = 4;
    //item2.comments = "Act amendments";
    //item2.createdDate = new Date("12/12/2018");
    //item2.createdBy = "RTR User";



    let requlatoryItems: ExternalDocumentDto[] = [item1];

    return requlatoryItems;

    //return this.costRecoveryChargeEndpoint.getCostRecoveryChargeById<CostRecoveryChargeDto>(costRecoveryChargeId);

  }

  submitRegulatoryItem(regulatoryItem: RegulatoryItemDto) {
    return this.regulatoryItemEndpoint.submitRegulatoryItem<BusinessRuleMessage[]>(regulatoryItem);
  }

  submitRegulatoryUpdate(regulatoryUpdate: RegulatoryUpdateDto) {
    return this.regulatoryItemEndpoint.submitRegulatoryUpdate<BusinessRuleMessage[]>(regulatoryUpdate);
  }

  async uploadExternalDocument(externalDocuments: ExternalDocumentDto[]) {
    let response = [];
    const formData = new FormData();
    for (let externalDocument of externalDocuments) {
      if (externalDocument.file != null) {
        formData.append(externalDocument.file.name, externalDocument.file);
      }
    }
    if (formData != null && externalDocuments.length > 0) {
      formData.append('folderkey', externalDocuments[0].regulatoryUpdateID);
      await this.regulatoryItemEndpoint.uploadExternalDocument(formData);
    }
    
    return response;
  }

  importLegislationRegulatoryItems(fileUpload: FileUploadDto) {
    const formData = new FormData();
    formData.append(fileUpload.fileName, fileUpload.file);
    formData.append('folderkey', fileUpload.key);
    return this.regulatoryItemEndpoint.importLegislationRegulatoryItems<BusinessRuleMessage[]>(formData);
  }

  importAgencyRegulatoryItems(fileUpload: FileUploadDto) {
    const formData = new FormData();
    formData.append(fileUpload.fileName, fileUpload.file);
    formData.append('folderkey', fileUpload.key);
    return this.regulatoryItemEndpoint.importAgencyRegulatoryItems<BusinessRuleMessage[]>(formData);
  }

  async uploadHelpFile(fileUpload: FileUploadDto) {
    const formData = new FormData();
    formData.append(fileUpload.fileName, fileUpload.file);
    formData.append('folderkey', fileUpload.key);
    return await this.regulatoryItemEndpoint.uploadHelpFile(formData);
  }
  
  downloadFile(externalDocumentID: string, fileName: string) {
    return this.regulatoryItemEndpoint.downloadFile(externalDocumentID, fileName);
  }

  downloadHelpFile(fileName: string) {
    return this.regulatoryItemEndpoint.downloadHelpFile(fileName);
  }
}
